import { Sparkles, MessageCircle } from "lucide-react";
import { useApp } from "@/context/AppContext";

const TXT = {
    fr: { default: "Demander au Directeur" },
    en: { default: "Ask the Director" },
    es: { default: "Preguntar al Director" },
};

/**
 * Small inline CTA: "Ask the Director" opens the DirectorChat panel with an optional preset prompt.
 * Usage: <AskDirector prompt="Peux-tu améliorer mon hook ?" testid="ask-director-hook" />
 */
export default function AskDirector({ prompt, label, testid = "ask-director", variant = "outline" }) {
    const { lang } = useApp();
    const t = TXT[lang] || TXT.fr;
    const finalLabel = label || t.default;

    const trigger = () => {
        window.dispatchEvent(new CustomEvent("sf:open-director", { detail: { prompt } }));
    };

    const base = "inline-flex items-center gap-1.5 kinetic text-xs font-mono-sf uppercase tracking-widest px-3 py-1.5 rounded";
    const styles = variant === "solid"
        ? "flame-gradient text-black font-semibold"
        : "border border-[#FF4D00]/40 text-[#FF4D00] hover:bg-[#FF4D00]/10";

    return (
        <button data-testid={testid} onClick={trigger} className={`${base} ${styles}`}>
            <Sparkles className="w-3.5 h-3.5" />
            {finalLabel}
        </button>
    );
}
